'use strict';

export default {
  lang: '',
  oemCompany: {},
  session: {},
  emailModel:{},
  screenSize:'',
  mobile:false
};



// WEBPACK FOOTER //
// ./src/store/state.js